import toast from "react-hot-toast";
import i18next from "i18next";
import {BaseClient} from "../../Api/HttpClient";

export const createContractSlice = (set, get) => ({
    contracts: [],
    contractsMetaData: {},
    contractDetail: {},

    getAllMyContracts: async (status = [], page = 1, searchFilter = null) => {
        let searchParams = new URLSearchParams();
        if (status?.length > 0) {
            searchParams.append('status', status.join(','));
        }
        if (page) {
            searchParams.append('page', page);
        }
        if (searchFilter) {
            searchParams.append('search', searchFilter);
        }

        await BaseClient().get(`/contracts?${searchParams}`)
            .then(response => {
                if (response.status === 200) {
                    set({contracts: response.data?.data})
                    set({contractsMetaData: response.data?.meta})
                    return response.data?.data;
                } else {
                    toast.error(response.data);
                }
            })
    },
    getContractDetail: async (contractId) => {
        await BaseClient().get(`/contracts/${contractId}`)
            .then(response => {
                if (response.status === 200) {
                    set({contractDetail: response.data})
                } else {
                    toast.error(response.data);
                }
            })
    },
    getContractsForUser: async (userId, page = 1, branchId = null) => {
        try {
            const params = new URLSearchParams();
            params.append('page', page);

            if (branchId) {
                params.append('branch_id', branchId);
            }

            const response = await BaseClient().get(`/users/${userId}/contracts?${params.toString()}`);
            if (response.status === 200) {
                return {
                    data: response.data?.data || [],
                    meta: response.data?.meta || {}
                };
            } else {
                toast.error(response.data);
                return { data: [], meta: {} };
            }
        } catch (error) {
            console.error('Error fetching contracts for user:', error);
            toast.error(i18next.t('contracts.toast_fetch_error'));
            return { data: [], meta: {} };
        }
    },
    regenerateContract: async (contractId) => {
        try {
            const response = await BaseClient().post(`/contracts/${contractId}/regenerate`);
            if (response.status === 200 || response.status === 201) {
                toast.success(i18next.t('contracts.toast_regenerate_success'));
                return true;
            } else {
                toast.error(response.data);
                return false;
            }
        } catch (error) {
            console.error('Error regenerating contract:', error);
            toast.error(i18next.t('contracts.toast_regenerate_error'));
            return false;
        }
    },
    regenerateContractForShift: async (shiftId) => {
        try {
            const response = await BaseClient().post(`/shifts/${shiftId}/regenerate-contract`);
            if (response.status === 200 || response.status === 201) {
                toast.success(i18next.t('contracts.toast_generate_for_shift_success'));
                return true;
            } else {
                toast.error(response.data);
                return false;
            }
        } catch (error) {
            console.error('Error generating contract for shift:', error);
            toast.error(i18next.t('contracts.toast_generate_for_shift_error'));
            return false;
        }
    },
})